import { formatTime } from 'src/features/locations/helpers'
import { Hours } from 'src/types/schema/graphql'

export const parseBusinessHours = (operationHours: Hours[]) => {
    return operationHours.map((entry) => {
        const { day, isOpen, hours } = entry
        const parsedHours = hours.map((hour) => {
            return {
                open: formatTime(hour[0]),
                close: formatTime(hour[1]),
            }
        })
        return {
            day,
            isOpen,
            hours: parsedHours,
        }
    })
}
